import * as React from 'react'
import MapView from './components/mapView'

function App() {
  return (
    <div id='app-container' style={{ 
      width: '100vw', 
      maxWidth: '100%', 
      overflow: 'visible',  // Changed from 'auto' to 'visible'
      margin: 0, 
      padding: 0 
    }}>
      <div style={{ width: '100%' }}>
        <MapView />
      </div>
    </div>
  )
}

export default App;
